/**
 * Helper function to omit keys from an object.
 * Typescript has the type helper `Omit` but no inbuild helper function to do the same on objects or arrays.
 * This method is a simple version of it by creating a shallow copy of th origin object and deleting the requested keys.
 *
 * @param obj The origin object
 * @param keys The keys to omit
 * @returns A shallow clone of the source object with the specified keys omitted
 */
export const omit = <T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> => {
  const result = { ...obj };
  keys.forEach((k) => {
    delete result[k];
  });
  return result;
};
